import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { LabelErro } from './Layout/LabelErro'
import { LabelSucesso } from './Layout/LabelSucesso'
import ReactLoading from "react-loading";
import api from '../services/api';
import { Button, Form } from 'react-bootstrap';
import { URL } from '../constants/index'

class RecuperarSenha extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: "",
            erroRecuperarSenha: "",
            sucessoRecuperarSenha: "",
            loading: false,
        }
    }

    handleEmail = e => {
        this.setState({ email: e.target.value })
    }

    onRetornarLogin = e => {
        this.props.history.push(URL.URLLogin)
    }

    startLoading() {
        this.setState({ loading: true })
    }

    stopLoading() {
        this.setState({ loading: false })
    }

    handleRecuperarSenha = e => {
        e.preventDefault();

        if (!this.validarFormulario()) {
            return false;
        }
        
        this.startLoading()

        api.post("/api/login/recuperarsenha", { email: this.state.email }, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(res => {
                this.tratarSucessoRecuperarSenha()
                this.stopLoading()
            })
            .catch(err => {
                this.stopLoading()
                
                if (err.response && err.response.data) {                
                    this.tratarErroRecuperarSenha(err.response.data.message)
                } else {                    
                    this.tratarErroRecuperarSenha("Erro ao se comunicar com API")
                }
            })


    }

    tratarSucessoRecuperarSenha = e => {
        this.setState({
            sucessoRecuperarSenha: "E-mail com instruções foi enviado com sucesso",
            erroRecuperarSenha: ""
        })

    }

    validarFormulario = e => {
        const { email } = this.state

        if (!email) {
            this.tratarErroRecuperarSenha("Preencha e-mail para continuar")
            return false;
        }
        return true;
    }

    tratarErroRecuperarSenha = erro => {
        this.setState({
            erroRecuperarSenha: erro,
            sucessoRecuperarSenha: ""
        })
    }

    render() {
        return (
            <Container style={{ paddingTop: "100px" }}>
                <Row className="justify-content-center">
                    <Col xs="6" style={{ padding: "20px" }} className="border" >
                        <Form onSubmit={this.handleRecuperarSenha}>
                            <h3>Recuperar senha</h3>
                            <h6>Informe seu e-mail para receber o token de autenticação</h6>
                            <hr/>
                            {this.state.erroRecuperarSenha ? <LabelErro caption={this.state.erroRecuperarSenha}></LabelErro> : null}
                            {this.state.sucessoRecuperarSenha ? <LabelSucesso caption={this.state.sucessoRecuperarSenha}></LabelSucesso> : null}
                            <Form.Group controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeHolder="Email" onChange={this.handleEmail} value={this.state.email} />
                            </Form.Group>

                            {!this.state.loading ?
                                <Button variant="dark" type="submit" block>Enviar</Button>
                                
                                :
                                <Row className="justify-content-center">
                                    <ReactLoading type="bubbles" color="#343a40" height={100} width={100} />
                                </Row>
                            }
                        </Form>
                        <br />
                        <Button variant="dark" onClick={this.onRetornarLogin} block>Retornar para login</Button>                                                                                
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default RecuperarSenha;